import { BackendResponseFormat } from "../utils/fetch";

export const errorCodes = {
  FORBIDDEN: 1000,
  EMAIL_VERIFICATION_REQUIRED: 1001,
  UNAUTHORIZED: 1002,
  TWO_FACTOR_AUTH_REQUIRED: 1003,
};

export class BackendError extends Error {
  statusCode: number;
  responseBody: BackendResponseFormat<unknown> | string;
  errorCode: number | undefined;

  constructor(
    statusCode: number,
    responseBody: BackendResponseFormat<unknown> | string,
  ) {
    if (typeof responseBody === "string") {
      responseBody = { message: responseBody };
    }

    super(responseBody?.message || "An error occurred");
    this.name = "BackendError";
    this.responseBody = responseBody;
    this.statusCode = statusCode;

    if (responseBody?.meta?.error_code) {
      this.errorCode = responseBody.meta.error_code;
    }
  }
}
